// import { createContext, useContext, useState } from "react";

// const StateContext = createContext({
//   user: null,
//   token: null,
//   setUser: () => {},
//   setToken: () => {},
// });

// export const ContextProvider = ({ children }) => {
//   const [user, setUser] = useState(
//     localStorage.getItem("USER") ? JSON.parse(localStorage.getItem("USER")) : {}
//   );
//   const [token, _setToken] = useState(localStorage.getItem("ACCESS_TOKEN"));
//   const [view, setView] = useState("appointments");

//   const setToken = (token) => {
//     _setToken(token);
//     if (token) {
//       localStorage.setItem("ACCESS_TOKEN", token);
//     } else {
//       localStorage.removeItem("ACCESS_TOKEN");
//     }
//   };

//   const _setUser = (user) => {
//     setUser(user);
//     if (user) {
//       localStorage.setItem("USER", JSON.stringify(user));
//     } else {
//       localStorage.removeItem("USER");
//     }
//   };

//   return (
//     <StateContext.Provider
//       value={{
//         user,
//         token,
//         _setUser,
//         setToken,
//         view,
//         setView,
//       }}
//     >
//       {children}
//     </StateContext.Provider>
//   );
// };

// export const useStateContext = () => useContext(StateContext);


import { createContext, useContext, useState } from "react";

const StateContext = createContext({
  user: null,
  token: null,
  view: "appointments",
  date: "", // 🛠️ Added initial date state
  setUser: () => {},
  setToken: () => {},
  setView: () => {},
  setDate: () => {}, // 🛠️ Added initial function placeholder
});

export const ContextProvider = ({ children }) => {
  const [user, setUser] = useState(
    localStorage.getItem("USER") ? JSON.parse(localStorage.getItem("USER")) : {}
  );
  const [token, _setToken] = useState(localStorage.getItem("ACCESS_TOKEN"));
  const [view, setView] = useState("appointments");
  
  // 🛠️ 1. Create the date state
  const [date, setDate] = useState(""); 

  const setToken = (token) => {
    _setToken(token);
    if (token) {
      localStorage.setItem("ACCESS_TOKEN", token);
    } else {
      localStorage.removeItem("ACCESS_TOKEN");
    }
  };

  const _setUser = (user) => {
    setUser(user);
    if (user) {
      localStorage.setItem("USER", JSON.stringify(user));
    } else {
      localStorage.removeItem("USER");
    }
  };

  return (
    <StateContext.Provider
      value={{
        user,
        token,
        _setUser,
        setToken,
        view,
        setView,
        // 🛠️ 2. Export date and setDate so other components can use them
        date,
        setDate, 
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);